import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolOperation,
} from '@saas-pages/shared/public/runtime'

const ANALYTICS_CONTEXT = {
  app: 'dateify',
  domain: 'dateify.ru',
  route: '/sekundomer',
  utility: 'stopwatch',
  processingMode: 'local',
} satisfies ToolAnalyticsContext

export class StopwatchAnalyticsSession {
  private operation: ToolOperation | null = null

  start(): void {
    this.operation ??= startToolOperation(ANALYTICS_CONTEXT)
  }

  recordMeasurement(): void {
    // The elapsed stopwatch value is user state, not an operation latency.
    // A non-finite duration makes the shared analytics contract omit duration_ms.
    this.operation?.success(Number.NaN)
  }

  end(): void {
    this.operation?.error('cancelled')
    this.operation = null
  }
}
